import BaseService from '../base-service';
import NetworkUrls from '../network-urls';

class ExtrasService extends BaseService {

  async step3ExtraList({ lang, room_id }) {
    const config = {
      url: NetworkUrls.graphql,
      method: 'POST',
      data: {
        query: `query ($lang: Lang!, $room_id: CID!) {
            Extras {
              edge_by_room (room_id: $room_id, limit: 100) {
                    id,
                    type,
                    price,
                    picture,
                    is_next_day,
                    time_to_lock,
                    number,
                    discount {
                        amount,
                        type,
                        is_available
                    },
                    text (lang: $lang) {
                        name,
                        description
                    }
                }
                many (limit: 6, inPromo: true, room_id: $room_id) {
                    id,
                    type,
                    price,
                    picture,
                    is_next_day,
                    time_to_lock,
                    number,
                    discount {
                        amount,
                        type,
                        is_available
                    },
                    text (lang: $lang) {
                        name,
                        description
                    }
                }
            },
            ExtraCategory {
                many {
                    text (lang: $lang) {
                        title
                    },
                    id,
                    extras (room_id: $room_id) {
                        id,
                        type,
                        price,
                        picture,
                        is_next_day,
                        time_to_lock,
                        number,
                        discount {
                            amount,
                            type,
                            is_available
                        },
                        text (lang: $lang) {
                            name,
                            description
                        }
                    }
                }
            }
        }`,
        variables: { lang, room_id }
      }
    };
    return this._exec(config);
  }

  async extraList({ lang }) {
    const config = {
      url: NetworkUrls.graphql,
      method: 'POST',
      data: {
        query: `query ($lang: Lang!) {
    Extras {
        many (limit: 100){
            id,
            type,
            price,
            picture,
            is_next_day,
            time_to_lock,
            number,
            discount {
                amount,
                type,
                is_available
            },
            text (lang: $lang) {
                name,
                description
            }
        }
    },
    ExtraCategory {
        many {
            text (lang: $lang) {
                title
            },
            id,
            extras {
                id,
                type,
                price,
                picture,
                is_next_day,
                time_to_lock,
                number,
                discount {
                    amount,
                    type,
                    is_available
                },
                text (lang: $lang) {
                    name,
                    description
                }
            }
        }
    }
}`,
        variables: { lang }
      }
    };
    return this._exec(config);
  }

}

export const extraService = new ExtrasService();



// WEBPACK FOOTER //
// ./src/network/services/extras.service.js